import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import Header from './components/Header';
import ExperienceItem from './components/ExperienceItem';
import ProjectCard from './components/ProjectCard';
import config from './config';
import ViewResume from './components/ViewResume';
import Footer from './components/Footer';
import CV from './pages/CV';
import Archive from './pages/Archive';
import ScrollToTop from './components/ScrollToTop';
import { FiArrowRight } from 'react-icons/fi';
import { parseText } from './utils/textParser';
import SectionHeader from './components/SectionHeader';

function MainContent() {
  return (
    <div className="portfolio">
      <div className="portfolio-left">
        <Header />
      </div>
      
      <div className="portfolio-right">
        <section id="about" className="about">
          <SectionHeader title="ABOUT" />
          {config.about.map((paragraph, index) => (
            <p key={index}>{parseText(paragraph)}</p>
          ))}
        </section>

        <section id="experience" className="work-experience">
          <SectionHeader title="EXPERIENCE" />
          {config.experiences.filter(exp => exp.type === "industry").map((exp, index) => (
            <ExperienceItem key={index} {...exp} />
          ))}
          <ViewResume />
        </section>

        <section id="projects" className="projects">
          <SectionHeader title="PROJECTS" />
          <div className="projects-grid">
            {config.projects.slice(0, 3).map((project, index) => (
              <ProjectCard key={index} project={project} />
            ))}
          </div>
          <Link to="/archive" className="view-archive">
            View Project Archive <FiArrowRight className="title-arrow title-arrow-right" />
          </Link>
        </section>
        <Footer />
      </div>
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<MainContent />} />
          <Route path="/cv" element={<CV />} />
          <Route path="/archive" element={<Archive />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
